export default "__VITE_PUBLIC_ASSET__87eb6d61__"